import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Server, Activity, AlertTriangle, HardDrive } from 'lucide-react';
import { services, systemTechInfos } from '../data/mockData';
import { StatCard } from '../components/ui/StatCard';
export function TechnicalDashboard() {
  const navigate = useNavigate();
  const activeSystems = services.filter(s => s.row_status === 'active');
  const totalSystems = activeSystems.length;
  return <div className="space-y-6" data-id="element-580">
      <div className="flex justify-between items-center" data-id="element-581">
        <div data-id="element-582">
          <h1 className="text-2xl font-bold text-slate-800" data-id="element-583">
            Technical Dashboard
          </h1>
          <p className="text-slate-500" data-id="element-584">
            System Health & Infrastructure Overview
          </p>
        </div>
        <div className="bg-emerald-100 text-emerald-800 px-4 py-2 rounded-lg font-medium flex items-center" data-id="element-585">
          <Activity className="w-4 h-4 mr-2" data-id="element-586" />
          {totalSystems} Systems Running
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-587">
        {activeSystems.map(service => {
        const techInfo = systemTechInfos[service.uuid] || {
          totalVm: 0,
          totalRunning: 0,
          totalDown: 0,
          totalContainer: 0,
          totalPod: 0,
          activePod: 0,
          alerts: []
        };
        const hasAlerts = techInfo.alerts.length > 0;
        return <div key={service.id} onClick={() => navigate(`/technical/${service.uuid}`)} className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 cursor-pointer hover:shadow-md hover:border-emerald-200 transition-all group" data-id="element-588">
              <div className="flex justify-between items-start mb-4" data-id="element-589">
                <div className="p-3 bg-slate-100 rounded-lg group-hover:bg-emerald-50 transition-colors" data-id="element-590">
                  <Server className="w-6 h-6 text-slate-600 group-hover:text-emerald-600" data-id="element-591" />
                </div>
                {hasAlerts && <span className="flex h-3 w-3 relative" data-id="element-592">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-593"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-594"></span>
                  </span>}
              </div>

              <h3 className="text-lg font-bold text-slate-800 mb-1" data-id="element-595">
                {service.name_en}
              </h3>
              <p className="text-sm text-slate-500 mb-4" data-id="element-596">{service.name}</p>

              <div className="space-y-3" data-id="element-597">
                <div className="flex justify-between items-center text-sm" data-id="element-598">
                  <div className="flex items-center text-slate-600" data-id="element-599">
                    <HardDrive className="w-4 h-4 mr-2" data-id="element-600" /> VMs
                  </div>
                  <div className="font-medium" data-id="element-601">
                    <span className="text-emerald-600" data-id="element-602">
                      {techInfo.totalRunning}
                    </span>
                    <span className="text-slate-400" data-id="element-603">/</span>
                    <span data-id="element-604">{techInfo.totalVm}</span>
                  </div>
                </div>

                <div className="flex justify-between items-center text-sm" data-id="element-605">
                  <div className="flex items-center text-slate-600" data-id="element-606">
                    <div className="w-4 h-4 mr-2" data-id="element-607" /> Pods
                  </div>
                  <div className="font-medium" data-id="element-608">
                    <span className="text-emerald-600" data-id="element-609">
                      {techInfo.activePod}
                    </span>
                    <span className="text-slate-400" data-id="element-610">/</span>
                    <span data-id="element-611">{techInfo.totalPod}</span>
                  </div>
                </div>

                {techInfo.totalDown > 0 && <div className="mt-3 pt-3 border-t border-slate-100 flex items-center text-xs text-red-600 font-medium" data-id="element-612">
                    <AlertTriangle className="w-3 h-3 mr-1" data-id="element-613" />
                    {techInfo.totalDown} VM(s) Down
                  </div>}
              </div>
            </div>;
      })}
      </div>
    </div>;
}